module.exports = __webpack_public_path__ + "static/media/state-name-and-code.c8b0f268.png";